module.exports = __webpack_public_path__ + "static/media/archive_framed.f313146f.png";